<template>
  <modal @close="$emit('close')">
    <template #body>
      <div class="modal-write">
        <div class="modal-write__form">
          <div class="modal-write__title">Подать заявку застройщика</div>
          <div class="modal-write__info">
            Оставьте контакты — расскажем об условиях размещения и форматах сотрудничества
          </div>

          <div v-if="success" class="frd-success">
            <div class="frd-success__icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 48 48">
                <circle cx="24" cy="24" r="23" stroke="#1B1918" stroke-width="1.5"/>
                <polyline points="14,24 21,31 34,17" fill="none" stroke="#1B1918" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3 class="frd-success__title">Заявка отправлена</h3>
            <p class="frd-success__text">Мы свяжемся с вами в ближайшее время и расскажем об условиях.</p>
          </div>

          <form v-else @submit.prevent="send" novalidate>
            <div class="modal-write__inputs-row">
              <Input placeholder="Ваше имя" type="text" class="input input-full" v-model="name" />
              <Input placeholder="Название компании или застройщика" type="text" class="input input-full" v-model="company" />
            </div>
            <div class="modal-write__inputs-row">
              <Input placeholder="Телефон" type="tel" class="input input-full" v-model="phone" />
              <Input placeholder="Email (необязательно)" type="email" class="input input-full" v-model="email" />
            </div>
            <div class="modal-write__input-box">
              <Textarea
                placeholder="Расскажите об объекте или проекте"
                class="input input-full"
                v-model="comment"
              />
            </div>

            <button type="submit" class="full-dark-btn fp-submit" :disabled="!agreed">
              Отправить заявку
            </button>

            <Checkbox
              label="Я согласен с <a href='/privacy'>обработкой персональных данных</a> и <a href='/oferta'>публичной офертой</a>"
              :isCheck="agreed"
              name="agreement_developer"
              @change="agreed = $event"
            />

            <p v-if="error" class="frd-error">{{ error }}</p>
            <LoginHint />
          </form>
        </div>
      </div>
    </template>
  </modal>
</template>

<script setup>
import LoginHint from "~/components/UI/LoginHint.vue";
import modal from '~/components/UI/Modal.vue'
import Input from '~/components/UI/inputs/Input.vue'
import Textarea from '~/components/UI/inputs/Textarea.vue'
import Checkbox from '~/components/UI/btn/Checkbox.vue'
import api from '~/api/api.js'

defineEmits(['close'])

const name    = ref('')
const company = ref('')
const phone   = ref('')
const email   = ref('')
const comment = ref('')
const agreed  = ref(false)
const success = ref(false)
const error   = ref('')

watch(phone, (val) => {
  let digits = val.replace(/\D/g, '')
  if (digits.startsWith('7') || digits.startsWith('8')) digits = digits.slice(1)
  digits = digits.slice(0, 10)
  let masked = '+7'
  if (digits.length > 0) masked += ' ' + digits.slice(0, 3)
  if (digits.length > 3) masked += ' ' + digits.slice(3, 6)
  if (digits.length > 6) masked += '-' + digits.slice(6, 8)
  if (digits.length > 8) masked += '-' + digits.slice(8, 10)
  if (phone.value !== masked) phone.value = masked
})

async function send() {
  error.value = ''
  if (!name.value.trim() || !company.value.trim() || !phone.value.trim()) {
    error.value = 'Заполните имя, компанию и телефон.'
    return
  }
  if (!agreed.value) {
    error.value = 'Подтвердите согласие.'
    return
  }

  const fd = new FormData()
  fd.append('name', name.value)
  fd.append('phone', phone.value)
  fd.append('message', `[Застройщик] Компания: ${company.value}${comment.value ? '\n' + comment.value : ''}`)
  if (email.value) fd.append('email', email.value)

  try {
    await api('/real-estate/inquiry', fd, 'POST')
    success.value = true
    name.value    = ''
    company.value = ''
    phone.value   = ''
    email.value   = ''
    comment.value = ''
  } catch {
    error.value = 'Произошла ошибка. Попробуйте ещё раз.'
  }
}
</script>

<style scoped lang="scss">
.frd-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 4rem 2rem 2rem;

  &__icon {
    margin-bottom: 2.4rem;
    svg { display: block; }
  }

  &__title {
    font-size: 2.4rem;
    font-weight: 500;
    color: #1B1918;
    margin-bottom: 1rem;
    line-height: 1.3;
  }

  &__text {
    font-size: 1.6rem;
    color: #888;
  }
}

.frd-error {
  margin-top: 1.2rem;
  font-size: 1.4rem;
  color: #c62828;
}
</style>
